export const resolveRegenerationInstructionChain = (
  processingResults,
  currentInstruction = '',
  serverChain = null
) => {
  const inputContext = processingResults?.batch_input_context || {};
  const sourceChain = Array.isArray(serverChain)
    ? serverChain
    : Array.isArray(processingResults?.regeneration_instruction_chain)
      ? processingResults.regeneration_instruction_chain
      : Array.isArray(inputContext.regeneration_instruction_chain)
        ? inputContext.regeneration_instruction_chain
        : [];
  const values = [...sourceChain, currentInstruction]
    .map((value) => String(value || '').trim())
    .filter(Boolean);
  const latestUnique = [];
  const seen = new Set();
  [...values].reverse().forEach((value) => {
    if (!seen.has(value)) {
      seen.add(value);
      latestUnique.unshift(value);
    }
  });
  return latestUnique.slice(-5);
};

export const appendRegenerationInstruction = (chain, instruction) =>
  resolveRegenerationInstructionChain(
    { regeneration_instruction_chain: Array.isArray(chain) ? chain : [] },
    instruction
  );
